import { HttpClient } from '@angular/common/http';
import { Inject } from '@angular/core';
import { CrudRowsServiceBase, ENVIRONMENT, HateoasMultipleResponseObject, PageSpecification, addPageSpecificationParameters, appendSerialisedHttpParams } from '@scisys-uim/uim-common';
import { ASSET_MAINTENANCE_TYPE, AssetMaintenance } from 'assets-model';
import { Observable } from 'rxjs';



export abstract class AssetMaintenanceRowsServiceBase<G> extends CrudRowsServiceBase<AssetMaintenance, number, G> {

  servicePath: string = '/assetmaintenance';

  constructor(protected http: HttpClient, 
      @Inject(ENVIRONMENT) protected environment: any) {
    super(http, environment, ASSET_MAINTENANCE_TYPE.entityDecorator);
  }

  public findByFullFilters(filters: any, pageSpec?: PageSpecification): Observable<HateoasMultipleResponseObject<AssetMaintenance>> {
    var params = appendSerialisedHttpParams(filters);

    if (pageSpec) {
      params = addPageSpecificationParameters(pageSpec, params);
    }
    return this.deserialiseMultipleResponse(this.http.get<HateoasMultipleResponseObject<AssetMaintenance>>(this.serviceBaseUrl + (pageSpec ? '/findByFullFilters' : '/findByFullFiltersUnpaged'), {
      params: params
    }));
  }
}



